/*
 * SPDX-FileCopyrightText: 2025 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
export enum Mode {
  MY_NOTES = 'my',
  SHARED_WITH_ME = 'shared',
  PUBLIC = 'public',
  VISITED = 'visited'
}
